import React from 'react';
import { useNavigate } from 'react-router-dom';

const RespondSuccess = ({ preorder }: { preorder: boolean }) => {
  const navigate = useNavigate();

  const handleContinue = () => {
    window.location.href = 'https://buildmystory.com/parents/';
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen w-full bg-[#FCFCFC] font-sofiaSans">
      <div className="flex flex-col items-center w-full max-w-sm p-8">
        <h1 className="text-3xl font-bold text-secondaryStoryBlackText text-center mb-3">
          You&apos;re All Set{' '}
          <span role="img" aria-label="party">
            🎉
          </span>
        </h1>
        <p className="text-left text-base text-secondaryStoryBlackText mb-8">
          {preorder
            ? 'Thanks for your order! Your child’s storybook is being prepared and will be printed in time for the classroom celebration. '
            : 'Thanks for confirming. Your child’s storybook is being prepared. We’ll email you updates and let you know when it’s ready to order in time for the classroom celebration.'}
        </p>
        <p className="text-left text-base font-bold text-secondaryStoryBlackText mb-6">
          Want to see how it works or check out examples? Just press continue below.
        </p>
        <button
          type="button"
          className="w-full py-2 flex items-center justify-center rounded-lg bg-secondaryStoryOrangeBackground text-whiteText font-bold text-base shadow-md hover:shadow-lg transition-shadow focus:outline-none focus:ring-2 focus:ring-secondaryStoryAdditionalLightBlueText focus:ring-offset-2"
          onClick={() => handleContinue()}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default RespondSuccess;
